<div class="zv-navigation-tabs__container">
  <nav mat-tab-nav-bar mat-stretch-tabs [tabPanel]="tabPanel">
    @for (link of navItems(); track trackByLink($index, link)) {
      <a
        [attr.data-cy]="link.dataCy"
        mat-tab-link
        [active]="link === active().link"
        [routerLink]="link.routerLink"
        [disabled]="link.disabled">
        {{ link.label }}
      </a>
    }
  </nav>
  @if (active().children.length > 0) {
    <mat-button-toggle-group class="zv-navigation-tabs__child-link-group">
      @for (child of active().children; track trackByLink($index, child)) {
        <mat-button-toggle
          [value]="child.routerLink"
          [attr.data-cy]="child.dataCy"
          class="zv-navigation-tabs__child-link"
          [routerLink]="child.routerLink"
          routerLinkActive="zv-navigation-tabs__child-link--active"
          >{{ child.label }}</mat-button-toggle
        >
      }
    </mat-button-toggle-group>
  }
  <mat-tab-nav-panel #tabPanel>
    <ng-content />
  </mat-tab-nav-panel>
</div>
